<template>
	<div v-if="task">
		<b-row class="justify-content-lg-center">
			<b-col>
				<b-card-title v-if="!inModal">{{ $t('task_title_show') }}</b-card-title>
                <b-list-group class="mb-2">
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_wash_station') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ task.washstation.name }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_worker') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ task.worker.firstname }} {{ task.worker.lastname }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
                <b-list-group class="mb-2">
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_start') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ $moment(task.startTime).format(this.dateFormat) }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_end') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ $moment(task.endTime).format(this.dateFormat) }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_duration') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ calcDuration(task.startTime, task.endTime) }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
                <b-list-group class="mb-2">
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_customer') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                <p v-if="!task.customer">
                                    <b-icon icon="exclamation-triangle-fill" scale="1.5" variant="warning" class="mr-1" />
                                    {{ $t('task_new_customer') }}
                                </p>
                                <p v-else>{{ task.customer.name }}</p>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item v-if="!task.customer">
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_customer_new_info') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ task.customerNew ? task.customerNew : "-" }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_products') }}:</b>
                                <b-badge class="ml-2" variant="primary" pill>{{ task.products.length }}</b-badge>
                            </b-col>
                            <b-col cols="8">
                                <ul class="mb-0">
                                    <li v-for="product in task.products" :key="product.id">
                                        {{ productString(product) }}
                                    </li>
                                </ul>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_registrations') }}:</b>
                                <b-badge class="ml-2" variant="primary" pill>{{ task.registrations.length }}</b-badge>
                            </b-col>
                            <b-col cols="8">
                                <ul class="mb-0">
                                    <li v-for="reg in task.registrations" :key="reg.id">
                                        {{ reg.number }}
                                    </li>
                                </ul>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item v-if="task.description">
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_description') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ task.description ? task.description : "-" }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
                <b-list-group>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_confirmed_at') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ task.confirmedAt ? $moment(task.confirmedAt).format(dateFormat) : $t('app_no') }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item  v-if="task.invoice && task.invoiceSentAt">
                        <b-row>
                            <b-col>
                                <b>{{ $t('task_label_invoice') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ $moment(task.invoiceSentAt).format(dateFormat) }}<br/>
                                <div v-if="invoice && invoice.id == task.invoice">
                                    Status: {{ invoice.status }}
                                </div>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
			</b-col>
		</b-row>
		<b-row class="justify-content-lg-center" v-if="!inModal">
			<b-col>
                <hr />
                <a :href="`/task`" type="button" class="btn btn-secondary">{{ $t('task_button_back_to_list') }}</a>
                <a v-if="checkRole(user, 'ROLE_ADMIN') || checkRole(user, 'ROLE_USER') && !task.confirmedAt" :href="`/task/${task.id}/edit`" type="button" class="btn btn-primary ml-2">{{ $t('task_button_edit') }}</a>
                <b-button @click="showCertificateModal" variant="info" class="ml-2">{{ $t('task_button_cleaning_certificate') }}</b-button>
			</b-col>
		</b-row>
        
        <task-certificate-modal 
            v-if="!inModal"
            ref="taskCertificateModal"
            :task="task"
            :loadCertificatePDF="loadCertificatePDF"
        />
	</div>
</template>

<script>
import TaskCertificateModal from './TaskCertificateModal.vue';

export default {
    name: 'TaskShow',
	components: {
        TaskCertificateModal,
	},
    props: [
        'user',
        'checkRole',
        'inModal',
        'task',
        'invoice',
        'getInvoice', 
        'customers',
        'products',
        'dateFormat',
		'translateUnit',
        'findById',
        'calcDuration',
        'checkTaskCustomer',
        'loadCertificatePDF',
    ],
    methods: {
        productString(product) {
            let apiProduct = this.findById(this.products, product.product);
            if (apiProduct) {
                let productStr = apiProduct.code ? `${apiProduct.code} - ${apiProduct.name} x ${product.amount} ${this.translateUnit(apiProduct.unit)}` : `${apiProduct.name} x ${product.amount} ${this.translateUnit(apiProduct.unit)}`;
                if (product.info) productStr += ` - ${product.info}`;
                return productStr;
            } else {
                return null;
            }
        },
        showCertificateModal() {
            this.$refs['taskCertificateModal'].$refs['certificateModal'].show();
        },
    },
    mounted () {
        if (this.task && this.task.invoice && !this.invoice || this.task && this.task.invoice && this.invoice.id != this.task.invoice) {
            this.getInvoice(this.task.invoice);
        }
    },
    watch: {
        task(task) {
            if (task.invoice && !this.invoice) {
                this.getInvoice(task.invoice);
            }
        }
    },
}
</script>